import React from "react";
import "./footer.css";

interface FooterProps{
}

const Footer:React.FC<FooterProps> = ({}) => {
    return (
        <footer>
            <div className="footer">
                <div>
                    2024 stavby sever
                </div>
                <div>
                    vytvořeno ve spolupráci s nejdePC
                </div>
            </div> 
        </footer>
    )
}

export default Footer;